import { render } from "./UpdatePinUser.vue?vue&type=template&id=15306a9d"
import script from "./UpdatePinUser.vue?vue&type=script&lang=js"
export * from "./UpdatePinUser.vue?vue&type=script&lang=js"

import exportComponent from "d:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__